import React from "react";
import { Input, Stack, Select } from "@chakra-ui/react";

function CustomInput(props) {
  const labelStyles = {
    color: "#2B2B21",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "normal",
    marginBottom: "10px",
    marginTop: "18px",
    display: "block",
    width: "90vw",
    maxWidth: "400px",
  };

  const inputStyles = {
    borderRadius: "16px",
    border: "2px solid #C7DDDA",
    background: "#FFF",
    height: "49px",
    alignSelf: "stretch",
    width: "90vw",
    maxWidth: "400px",
  };

  return (
    <div>
      <label style={labelStyles}>{props.label}</label>
      <Stack>
        {props.type === "select" ? ( // Verificar si el tipo de entrada es un select
          <Select
            style={inputStyles}
            size="lg"
            value={props.value}
            onChange={props.onChange}
          >
            {props.options &&
              props.options.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
          </Select>
        ) : (
          <Input
            type={props.type}
            style={inputStyles}
            size="lg"
            value={props.value}
            onChange={props.onChange}
          />
        )}
      </Stack>
    </div>
  );
}

export default CustomInput;
